import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { useEffect, useId, useState } from 'react';
import { useI18N } from '../../context/I18NContext';
import { Box, Button, FormControl, IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { styled } from '@mui/material/styles';
const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import ErrorAlert from '../ErrorAlert';
import ConfigHolder from '../../config/ConfigHolder';
import { useFormContext } from 'react-hook-form';
export default function UploadField(props) {
    const { t, ts } = useI18N();
    const fieldId = useId();
    const { getValues, setValue, register, formState: { errors } } = useFormContext();
    const [error, setError] = useState();
    const [thumbnail, setThumbnail] = useState();
    const [maxFiles, setMaxFiles] = useState(1);
    const [fileTypes, setFileTypes] = useState(['image', 'pdf']);
    const [mimeTypes, setMimeTypes] = useState([]);
    const [selectedFiles, setSelectedFiles] = useState([]);
    useEffect(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if ((_b = (_a = props.field) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.maxFiles) {
            setMaxFiles((_d = (_c = props.field) === null || _c === void 0 ? void 0 : _c.config) === null || _d === void 0 ? void 0 : _d.maxFiles);
        }
        if ((_f = (_e = props.field) === null || _e === void 0 ? void 0 : _e.config) === null || _f === void 0 ? void 0 : _f.fileTypes) {
            setFileTypes((_h = (_g = props.field) === null || _g === void 0 ? void 0 : _g.config) === null || _h === void 0 ? void 0 : _h.fileTypes);
        }
        let _mineTypes = [];
        if (fileTypes.includes('image')) {
            _mineTypes.push('image/*');
        }
        if (fileTypes.includes('pdf')) {
            _mineTypes.push('application/pdf');
        }
        setMimeTypes(_mineTypes);
        let value = getValues(props.name);
        if (value && value[0]) {
            setThumbnail(`${ConfigHolder.apiBaseUrl}${value[0].thumbnail}`);
        }
    }, []);
    async function upload(file) {
        try {
            let fieldId = props.name.substring(13); // strip of custom-field-
            const formData = new FormData();
            formData.append('qqfile', file);
            let url = new URL(`/forms/upload/save/fieldId/${fieldId}`, ConfigHolder.apiBaseUrl);
            url.searchParams.set('qquuid', '');
            url.searchParams.set('qqfilename', file.name);
            url.searchParams.set('qqtotalfilesize', file.size.toString());
            const response = await fetch(url, {
                headers: {},
                method: "POST",
                body: formData,
            });
            const result = await response.json();
            if (result.success) {
                let _files = selectedFiles;
                _files.push(result.file);
                setSelectedFiles(_files);
                setThumbnail(`${ConfigHolder.apiBaseUrl}${selectedFiles[0].thumbnail}`);
                setValue(props.name, [result.file]);
            }
            else {
                setThumbnail(undefined);
            }
        }
        catch (error) {
            console.error("Error:", error);
        }
    }
    const onChange = (event) => {
        var _a;
        if (event.target.files) {
            const files = (_a = event.target.files) !== null && _a !== void 0 ? _a : new FileList;
            if (files) {
                if (files.length > maxFiles) {
                    setError([ts('Je kunt maximaal %maxFiles% bestanden selecteren', { maxFiles: maxFiles }, 'register')]);
                }
                else {
                    setSelectedFiles([]);
                    for (const file of files) {
                        upload(file);
                    }
                }
            }
        }
    };
    const deleteFile = () => {
        var _a;
        setSelectedFiles([]);
        setValue(props.name, undefined);
        setThumbnail(undefined);
        // @ts-ignore
        (_a = document.getElementById(fieldId)) === null || _a === void 0 ? void 0 : _a.value = '';
    };
    return (_jsxs(_Fragment, { children: [thumbnail && (_jsxs(Box, { my: 2, sx: { position: 'relative', width: '100px' }, children: [_jsx("img", { src: thumbnail, height: "100px", style: {
                            width: '100px',
                            height: '100px',
                            borderRadius: '16px'
                        } }), _jsx(IconButton, { sx: {
                            position: 'absolute',
                            top: '8px',
                            right: '8px',
                            backgroundColor: '#fff'
                        }, onClick: deleteFile, children: _jsx(DeleteIcon, {}) })] })), _jsx(FormControl, { sx: { marginY: 1 }, fullWidth: true, children: _jsxs(Button, { component: "label", role: undefined, variant: "contained", tabIndex: -1, startIcon: _jsx(CloudUploadIcon, {}), children: [t(props.field.label, 'register'), " ", props.field.required && (_jsx(_Fragment, { children: "*" })), _jsx(VisuallyHiddenInput, { multiple: maxFiles > 1, accept: mimeTypes.join(','), type: "file", name: props.name, onChange: onChange, id: fieldId })] }) }), error && error.length > 0 && (_jsx(ErrorAlert, { messages: error, setter: setError }))] }));
}
